<template>
  <b-navbar
   class="navbar"
   >
    <template #brand>
      <b-navbar-item tag="router-link" :to="{ path: '/tandc' }">
        <img src="/assets/logo_horizontal.png" alt="MallShopLink logo" />
      </b-navbar-item>
    </template>
    <template #start>
      <b-navbar-item v-if="user" tag="router-link" :to="{ path: '/Shops' }"
      :active="path == '/Shops'">{{
        $t("ImportRevenues")
      }}</b-navbar-item>
      <b-navbar-item
        v-if="user"
        tag="router-link"
        :to="{ path: '/Shops/Admin' }"
        :active="path == '/Shops/Admin'"
        >{{ $t("Shops") }}</b-navbar-item>
        <b-navbar-item
        v-if="user"
        tag="router-link"
        :to="{ path: '/Members/Admin' }"
        :active="path == '/Members/Admin'"
        >{{ $t("Members") }}</b-navbar-item
      >
      <b-navbar-item
        v-if="user"
        tag="router-link"
        :to="{ name: 'notificationGroupAdmin' }"
        :active="path == '/notificationGroup/admin'"
        >{{ $t("NotificationGroups") }}</b-navbar-item
      >
      <b-navbar-item
        v-if="user"
        tag="router-link"
        :to="{ name: 'SectionsAdministration' }"
        :active="path == '/sections/admin'"
        >{{ $t("Sections") }}</b-navbar-item
      >
        <b-navbar-item
        v-if="user"
        tag="router-link"
        :to="{ path: '/Chains/Admin' }"
        :active="path == '/Chains/Admin'"
        >{{ $t("Chain") }}</b-navbar-item>
      <b-navbar-item tag="router-link" :to="{ path: '/ContactUs' }"
      :active="path == '/ContactUs'">{{
        $t("ContactUs")
      }}</b-navbar-item>
    </template>
    <template #end>
      <localeSwitch/>
      <b-navbar-item tag="div" v-if="user">{{ user.name }}</b-navbar-item>
      <b-navbar-item  v-if="!user" tag="div">
        <b-button
          class="loginButton"
          data-test-id="loginButton"
          @click="login"
        >
          <strong>{{ $t("SignIn") }}</strong>
        </b-button>
      </b-navbar-item>
      <b-navbar-item>
        <b-button
          class="logoutButton"
          type="is-text"
          data-test-id="logoutButton"
          @click="logout"
          v-if="user"
        >
          <strong>{{ $t("LogOut") }}</strong>
        </b-button>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import AuthEngine from "@/plugins/msal"
import { useAppStore } from "@/stores/app"
import * as Sentry from "@sentry/browser"
import localeSwitch from "@/components/localeSwitch.vue"

// Define component name for DevTools
defineOptions({
  name: 'NavigationBar'
})

// Composables
const route = useRoute()
const appStore = useAppStore()

// Computed properties
const user = computed(() => appStore.getAuthenticatedUser)
const path = computed(() => route.path)

// Methods
const login = () => {
  AuthEngine.login()
}

const logout = () => {
  AuthEngine.logout()
}

// Watchers
watch(user, (newUser) => {
  if (newUser && newUser.name) {
    Sentry.setUser({
      username: newUser.name
    })
  }
})
</script>
<style lang="scss">
//logout button color fx on a darker background added to avoid bringing !important that comes with is-white class
//to easily change the color on hover to a darker
.navbar .logoutButton.is-text{
  color: white;
}
.navbar .navbar-item:hover .logoutButton{
  color: inherit;
}
//end logout btn color fx

//start overflow treat on smaller dispays
@media screen and (min-width:1024px) and (max-width:1260px){
  .navbar{
   flex-wrap: wrap;
    .navbar-item{
     padding: 0.5rem;
    }
  }
  .navbar-brand{
   flex-basis: 100%;
   flex-grow: 1;
    a{
    margin: 0 auto;
    }
  }
  .navbar-menu {
    flex-grow: 1;
    flex-basis: 100%;
  }
}
//end overflow treat on smaller dispays

//start rtl -ltr mirroring fx
@media screen and (min-width:1024px){
 .navbar .navbar-start,
 .navbar .navbar-end{
   margin: 0;
  }
  .navbar-menu{
   justify-content: space-between;
  }
}
@media screen and (max-width:1024px){
  .navbar-brand{
    justify-content: space-between;
    .burger{
      margin: 0;
    }
  }
}
// Active navbar item contrast fix
  .navbar .navbar-item.is-active,
  .navbar .navbar-item.router-link-active {
    background-color: white;
    color: #363636; // or any dark color that works with your design
  }

  .navbar .navbar-item:hover {
    background-color: #f5f5f5;
    color: #363636;
  }
//end rtl -ltr mirroring fx
</style>
